<template>
  <div class="user-wrp-comments mydorm-galeri galeri-thumb">
    <div class="galeri-wrp" style="margin-top: 15px;">
      <div class="row">
        <div class="col-xs-12 col-md-12 galeri-left">
          <div class="galeri-left-wrp">
            <div class="galeri-left__item" v-for="item in gallery" :key="item.id">
              <img class="galeri-left__item-img" :src="item.logo" alt="">
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Offers',
  data () {
    return {
      gallery: [
        {
          id: 0,
          logo: require('@/assets/img/yurt-img-1.jpg')
        },
        {
          id: 1,
          logo: require('@/assets/img/yurt-img-4.jpg')

        },
        {
          id: 2,
          logo: require('@/assets/img/yurt-img-2.jpg')

        },
        {
          id: 3,
          logo: require('@/assets/img/yurt-img-1.jpg')

        },
        {
          id: 4,
          logo: require('@/assets/img/yurt-img-1.jpg')

        },
        {
          id: 5,
          logo: require('@/assets/img/yurt-img-4.jpg')

        },
        {
          id: 6,
          logo: require('@/assets/img/yurt-img-4.jpg')

        }

      ]
    }
  }

}
</script>

<style lang="scss">
  @import "../assets/scss/components/mydorm-galeri";

  .galeri-thumb{
      .galeri-left__item{
        width: 129px;
      }
    .galeri-left:after{
      display: none;
    }
  }
</style>
